<p-toast></p-toast>

<div class="my-hr-page-grid">
  <app-page-form-section
    icon="fa-solid fa-calendar-plus"
    title="Request leave"
    subtitle="A simpler employee leave request flow with balances and status in one place.">
    <div class="form-grid">
      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-briefcase"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-select
            inputId="leaveTypeId"
            [options]="leaveTypeOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="requestForm.leaveTypeId"
            [filter]="true"
            [showClear]="true"
            appendTo="body"></p-select>
          <label for="leaveTypeId">Leave type</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="toggle-group">
        <p-inputgroup-addon><i class="pi pi-bolt"></i></p-inputgroup-addon>
        <label class="checkbox-row">
          <p-checkbox inputId="leaveEmergency" binary="true" [(ngModel)]="requestForm.emergencyLeave"></p-checkbox>
          <span>Emergency leave</span>
        </label>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-calendar-plus"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-datepicker inputId="leaveStartDate" [(ngModel)]="requestForm.startDate" [showIcon]="true" appendTo="body"></p-datepicker>
          <label for="leaveStartDate">Start date</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-calendar"></i></p-inputgroup-addon>
        <p-iftalabel>
          <p-datepicker inputId="leaveEndDate" [(ngModel)]="requestForm.endDate" [showIcon]="true" appendTo="body"></p-datepicker>
          <label for="leaveEndDate">End date</label>
        </p-iftalabel>
      </p-inputgroup>

      <p-inputgroup class="form-span-2">
        <p-inputgroup-addon><i class="pi pi-comment"></i></p-inputgroup-addon>
        <p-iftalabel>
          <textarea id="leaveReason" pInputTextarea [(ngModel)]="requestForm.reason" rows="5"></textarea>
          <label for="leaveReason">Reason for leave</label>
        </p-iftalabel>
      </p-inputgroup>
    </div>

    @if (selectedType || selectedBalance) {
      <div class="leave-hint">
        <div>
          <span>Selected leave</span>
          <strong>{{ selectedType?.leaveName || selectedType?.leaveCode || 'Leave type' }}</strong>
        </div>
        <div>
          <span>Available days</span>
          <strong>{{ selectedBalance?.availableDays ?? '-' }}</strong>
        </div>
        <div>
          <span>Pending days</span>
          <strong>{{ selectedBalance?.pendingDays ?? '-' }}</strong>
        </div>
      </div>
    }

    <div class="panel-actions-row">
      <button pButton type="button" label="Submit request" icon="pi pi-send" [disabled]="!canRequestLeave" [loading]="submitting" (click)="submit()"></button>
    </div>
  </app-page-form-section>

  <app-page-data-panel
    title="Leave balances"
    subtitle="Current available, used, and pending leave by type."
    [resultText]="(workspace?.leaveBalances?.length || 0) + ' balances'">
    @if (workspace?.leaveBalances?.length) {
      <div class="balance-grid">
        @for (balance of workspace?.leaveBalances || []; track balance.leaveBalanceId) {
          <article class="balance-card">
            <h4>{{ balance.leaveName || balance.leaveCode }}</h4>
            <div class="balance-values">
              <div><span>Available</span><strong>{{ balance.availableDays ?? 0 }}</strong></div>
              <div><span>Used</span><strong>{{ balance.usedDays ?? 0 }}</strong></div>
              <div><span>Pending</span><strong>{{ balance.pendingDays ?? 0 }}</strong></div>
            </div>
          </article>
        }
      </div>
    } @else {
      <p class="empty-state">No leave balances available yet.</p>
    }
  </app-page-data-panel>
</div>

  <app-page-data-panel
    title="Request history"
    subtitle="Your submitted leave requests and approval status."
    [resultText]="(workspace?.requests?.length || 0) + ' requests'">
  @if (workspace?.requests?.length) {
    <p-table [value]="workspace?.requests || []" responsiveLayout="stack" breakpoint="768px">
      <ng-template pTemplate="header">
        <tr>
          <th>Type</th>
          <th>Period</th>
          <th>Days</th>
          <th>Status</th>
          <th>Submitted</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-request>
        <tr>
          <td><span class="p-column-title">Type</span>{{ request.leaveName || request.leaveCode }}</td>
          <td><span class="p-column-title">Period</span>{{ request.startDate | date:'mediumDate' }} - {{ request.endDate | date:'mediumDate' }}</td>
          <td><span class="p-column-title">Days</span>{{ request.requestedDays ?? request.paidDays ?? '-' }}</td>
          <td><span class="p-column-title">Status</span><p-tag [value]="label(request.requestStatus)" [severity]="statusSeverity(request.requestStatus)"></p-tag></td>
          <td><span class="p-column-title">Submitted</span>{{ request.submittedAt | date:'medium' }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="empty-state">No leave requests submitted yet.</p>
  }
</app-page-data-panel>
